// extracted by mini-css-extract-plugin
module.exports = {"operation_button":"index_operation_button__T9CM_"};